import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const BulletLowerGreekIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletLowerGreek",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.3 2.19c-.1.89-.24 3.77-.24 5.99 0 .99.25 1.41.84 1.43l-.13 1.08c-.08.02-.17.03-.26.03s-.18-.01-.27-.03c-.74 0-1.35-.49-1.43-1.68a3.25 3.25 0 0 1-2.85 1.68h-.02c-1.99 0-3.37-1.68-3.37-4.21 0-.11-.02-.23-.02-.35A4.16 4.16 0 0 1 7.18 2h.12c1.12 0 2.07.69 2.47 1.67v.02c.03-.55.09-1.07.17-1.57v.08h1.34ZM7.29 9.56a2.61 2.61 0 0 0 2.24-2.12v-.02c.07-.31.11-.66.11-1.02v-.17c.02-.13.03-.28.03-.44s0-.31-.03-.46v.02A2.424 2.424 0 0 0 7.51 3.2H7.5c-1.41 0-2.39 1.4-2.39 3.37-.08 1.53.71 3 2.19 3ZM5.08 25.27v1.83c0 .99.08 1.96.22 2.9v-.11H3.75a11.5 11.5 0 0 1-.28-2.57c0-.21 0-.42.02-.62v.03-8.6c-.02-.19-.03-.4-.03-.62 0-1.43.54-2.74 1.44-3.73.66-.64 1.56-1.04 2.56-1.04h.27a3.15 3.15 0 0 1 3.15 3.15v.12c0 1.21-.67 2.27-1.67 2.82h-.02v.09c1.6.33 2.78 1.73 2.78 3.4v.35c0 2.07-1.68 3.75-3.75 3.75H8h.01-.18c-1.06 0-2.01-.44-2.7-1.15s-.03 0-.03 0Zm0-1.68c.55.89 1.52 1.48 2.62 1.5s.04 0 .07 0a2.49 2.49 0 0 0 2.49-2.49v-.18c0-1.5-1.21-2.71-2.71-2.71h-.72v-1.04h.32a2.24 2.24 0 0 0 2.11-2.24v-.2c0-.06.01-.14.01-.23 0-1.07-.85-1.93-1.91-1.95-1.52 0-2.31 1.31-2.31 3.89l.02 5.64Zm22.61-8.11H14.22c-.46 0-.84.38-.84.84s.38.84.84.84h13.47c.46 0 .84-.38.84-.84s-.38-.84-.84-.84m-6.73 5.05h-6.73c-.46 0-.84.38-.84.84s.38.84.84.84h6.73c.46 0 .84-.38.84-.84s-.38-.84-.84-.84M14.23 4.54H27.7c.46 0 .84-.38.84-.84s-.38-.84-.84-.84H14.23c-.46 0-.84.38-.84.84s.38.84.84.84m0 5.05h6.73c.46 0 .84-.38.84-.84s-.38-.84-.84-.84h-6.73c-.46 0-.84.38-.84.84s.38.84.84.84"
    })
  }));
};